export default __webpack_public_path__ + "static/media/polish-ui.5512ca41.png";